import React from "react";
import PropTypes from "prop-types";

import ValidationMessage from "./ValidationMessage";

const ValidationGroup = (props) => {

    const {
        messages,
        children,
        validationMessageType
    } = props;

    const hasMessages = messages !== undefined;
    const className = hasMessages ? "o-col-12" : null;
    const outlineColor = validationMessageType === 'warning' ? "#ff8200" : "#c6005b";
    const style = hasMessages ? { outline: "1px solid " + outlineColor, outlineOffset: "10px" } : null;

    return (
        <div>
            <div className={className} style={style}>{children}</div>
            <div>
                &nbsp;
            </div>
            <div className={"u-clear o-col-12"}>
                <ValidationMessage message={messages} type={validationMessageType} />
            </div>
        </div>
    );
};

ValidationGroup.propTypes = {
    messages: PropTypes.string,
    children: PropTypes.node,
    validationMessageType: PropTypes.string
};

export default ValidationGroup;
